<section class="hero-section">
        <div class="floating-element floating-1"></div>
        <div class="floating-element floating-2"></div>
        
        <div class="container">
            <div class="hero-content">
                <div class="hero-left">
                    <div class="badge">SAT</div>
                    <h1>
                        <span class="highlight">SAT Mock Tests</span><br>
                        Master Your Exam
                    </h1>
                    <p class="subtitle">FULL MOCK | MINI MOCK</p>
                    <p class="description">
                        Professional exam preparation with realistic testing conditions. 
                        Build confidence and achieve your target score with our comprehensive mock test platform.
                    </p>
                    
                    <div class="features-inline">
                        <div class="feature-item">
                            <div class="feature-icon">✓</div>
                            <span>Face to Face</span>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">✓</div>
                            <span>Online</span>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">✓</div>
                            <span>Paper at Home</span>
                        </div>
                    </div>
                    
                    <button class="cta-button" (click)="scrollToCalendar()">
                        View Calendar →
                    </button>
                </div>
                
                <div class="hero-right">
                    <div class="image-card">
                        <img src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&h=600&fit=crop" alt="Student studying">
                        <div class="stat-badges">
                            <div class="stat-badge">
                                <div class="stat-value">98%</div>
                                <div class="stat-label">Success Rate</div>
                            </div>
                            <div class="stat-badge">
                                <div class="stat-value">25,000+</div>
                                <div class="stat-label">Students</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

<div class="cal-inst">
  <h1>Mock Test Calender</h1>
  <h2>SELECT THE DATE/CENTER BELOW & CLICK BOOK BUTTON</h2>
</div>


<section class="mock-calendar" id="calendar-section">

  <!-- FILTER TOOLBAR -->
  <div class="toolbar container-fluid">
    <div class="toolbar-row">
      <!-- Category -->
     <div class="toolbar-item">
  <label>Test Category</label>
  <div class="dropdown-like">

    <select [(ngModel)]="filters.categoryId" (change)="applyFilters()">
  <option [ngValue]="null">All</option>
  <option *ngFor="let c of SATCategories" [ngValue]="c.category_name">
    {{ c.category_name }}
  </option>
</select>

    <span class="chev">▾</span>
  </div>
</div>

      <!-- Pattern -->
      <div class="toolbar-item">
        <label>Test Pattern</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.pattern" (change)="applyFilters()">
            <option [ngValue]="null">All</option>
            <option *ngFor="let p of patterns" [ngValue]="p">
              {{ p }}
            </option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Mode -->
      <div class="toolbar-item">
        <label>Test Mode</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.mode" (change)="applyFilters()">
            <option [ngValue]="null">Both</option>
            <option value="Online Session">Online</option>
            <option value="Classroom Session">Face to Face</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Months -->
      <div class="toolbar-item">
        <label>Months</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.month" (change)="applyFilters()">
            <option [ngValue]="null">Any</option>
            <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Center -->
      <div class="toolbar-item">
        <label>Center</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.center" (change)="applyFilters()">
            <option [ngValue]="null">Any</option>
            <option *ngFor="let l of centers" [ngValue]="l">{{ l }}</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Reset -->
      <div class="toolbar-item">
        <label>Reset Filters</label>
        <div class="dropdown-like">
          <button class="reset-btn" (click)="resetFilters()">Reset</button>
        </div>
      </div>
    </div>

    <!-- Search -->
    <div class="search-item">
      <label>Search</label>
      <input type="text"
        type="text"
  class="form-control search-input"
  placeholder="Search SAT tests by name, location, type…"
  [(ngModel)]="filters.search"
  (input)="applyFilters()" />
    </div>
  </div>

  <!-- LIST BODY -->
  <div class="test-card-listing-body container list-body">
    <ng-container *ngIf="testList && testList.length > 0; else nothingFound">
      <div class="session-card test-card" *ngFor="let t of testList">

        <!-- Date -->
        <div class="date-chip">
          <span>{{ trimChar(t.test_date, 11) }}</span>
        </div>

        <!-- Session Info -->
        <div class="session-info">
          <a class="session-title">{{ t.category || 'SAT Test' }}</a>
          <a class="session-subtitle">
            <span [ngClass]="getPatternClass(t.test_name)">
              {{ getPatternFromName(t.test_name) }}
            </span>
          </a>
          <a class="session-pattern">{{ t.test_name }}</a>
        </div>

        <!-- Badges -->
        <div class="badges">
          <span class="badge"
                [ngClass]="t.exam_type === 'Online Session' ? 'badge-online' : 'badge-ff'">
            {{ t.exam_type === 'Online Session' ? 'Online' : 'Face to Face' }}
          </span>

          <span *ngIf="t.location || t.all_location" class="location-badge">
            <img src="assets/images/pin.png" alt="" />
            <span class="truncate" [title]="t.all_location || t.location">
              {{ trimChar(t.all_location || t.location) }}
            </span>
          </span>
        </div>

        <!-- Price -->
        <div class="price">
          <ng-container *ngIf="t.payment_method === 'Free'; else priced">
            Free
          </ng-container>
          <ng-template #priced>Price: £{{ t.test_fees }}</ng-template>
        </div>

        <!-- Book Button -->
        <div class="action">
          <a class="btn btn-book"
            [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
            Book
          </a>
        </div>
      </div>
    </ng-container>

    <ng-template #nothingFound>
      <div class="text-center py-5">No SAT Test Found</div>
    </ng-template>
  </div>
</section>


   <div class="section-8">


    <h1>What Parents Say About Us?</h1>
 
    <div class="sec-4">
 
     
       <div class="cs-sec">
     
         <div class="cs-crd">
           <div class="crd-cir">
             <h4 style="margin: 0px;">JS</h4>
           </div>
           <div class="info">
             <p style="font-weight: bold;">Jaya Rani</p>
             <p style="text-align: justify;">My son did Sehyog Mock Test, it’s very helpful to know which areas my son is
               lacking. Sehyog result analysis gives us understanding on which area the aspirant/parent needs to improve and
               concentrate on, which is very important in 11 plus journey, apart from that Sehyog also provides you guidance
               on how to submit CAF form with the school preferences and clarified most of our doubts. Thank you so much
               Sehyog team for your all your efforts.</p>
     
           </div>
         </div>
     
         <iframe  src="https://www.youtube.com/embed/YmSbI_LnpMM?si=c3_tmAft5PnRFfTi"
           title="Happy Parents Speak: Success Stories &amp; Testimonials 01" frameborder="0"
           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
           referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>


           <div class="cs-crd">
            <div class="crd-cir">
              <h4 style="margin: 0px;">AD</h4>
            </div>
            <div class="info">
              <p style="font-weight: bold;">Asima Dar</p>
              <p style="text-align: justify;">My son got admission in KEGS. Thank you so much SEHYOG. Your mocks were awesome; and my son learnt a lot because of these mocks. I am thinking that if my son didn't do these mocks, he may not have got admission in KEGS...Thank you again SEHYOG family!</p>
      
            </div>
          </div>
     
       </div>


     
       <!-- Testimonial Ends -->
     
       <div class="cs-sec">
     
     
         <iframe src="https://www.youtube.com/embed/n1OKFV6Wa68?si=dmvYHE9sCWxIzjr9" title="Happy Parents Speak: Success Stories &amp; Testimonials 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
     
         <div class="cs-crd">
           <div class="crd-cir">
             <h4 style="margin: 0px;">MD</h4>
           </div>
           <div class="info">
             <p style="font-weight: bold;">Mini Dagar</p>
             <p style="text-align: justify;">My son attended the mock exams by 11plushelpclub and it helped us a lot. With
               the detailed results every week, we knew which area to work on. Topic wise tests were a great form of
               revision. All the help by whole team was fabulous which helped my son to secure a safe place at school of his
               choice. Big thanks to everyone out there for all the help and guidance - Mini Dagar</p>
     
           </div>
         </div>

         <iframe src="https://www.youtube.com/embed/fVU0xDgiclA" title="Happy Parents Speak: Success Stories &amp; Testimonials 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
     
       </div>
     </div>
    
 
 
   </div>

